import type { PropertyPickerOption } from "@repo/ui/components/property-picker";
import { Status, StatusLabel } from "@repo/ui/components/ui/status";

type StatusVariant = "default" | "success" | "error" | "warning" | "info";

export interface StatusPickerOption extends PropertyPickerOption {
  variant: StatusVariant;
}

export function renderStatusItem(option: PropertyPickerOption) {
  const statusOpt = option as StatusPickerOption;
  return (
    <Status variant={statusOpt.variant} className="border-0 bg-transparent px-0 py-0">
      <StatusLabel>{option.label}</StatusLabel>
    </Status>
  );
}
